import { useState } from "react";
import {
  useCreateNewAdminUser,
  useDownloadAdminUsers,
  useFetchAllAdminUsers,
} from "../../hooks/api";
import { toast } from "react-toastify";
import { saveAs } from "file-saver";
import useDeleteMethod from "../../hooks/utils/useDeleteMethod";
export const useUserLogic = () => {
  const [filters, setFilters] = useState<Filters>({
    pageSize: 10,
    searchTerm: "",
    pageNumber: 1,
  });
  const handleSearchTerm = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilters((prev) => ({ ...prev, searchTerm: e.target.value }));
  };
  const adminUserList = useFetchAllAdminUsers(filters);

  const createAdmin = useCreateNewAdminUser();
  const downloadAdmin = useDownloadAdminUsers(filters);
  const handleDownloadAdminUsers = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    toast.dismiss();
    const loading = toast.loading(`Downloading Users`);
    return downloadAdmin.mutate(undefined, {
      onSuccess: (response) => {
        saveAs(response, "Admin Users.csv");
      },
      onSettled: () => {
        toast.dismiss(loading);
      },
    });
  };

  const deleteMethod = useDeleteMethod();
  const handleDelete = (id: string, service?: string) => {
    deleteMethod.handleDelete("invitation", id, service, () =>
      adminUserList.refetch()
    );
    // new Promise((res, rej) => {
    //   res(deleteMethod.handleDelete("invitation", id, service));
    // }).then(() => {
    //   const loader = toast.loading(`Deleting, Please Wait`);
    //   adminUserList.refetch().finally(() => toast.dismiss(loader));
    // });
  };
  const handlePagination = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setFilters((prev) => ({ ...prev, pageNumber: value }));
  };

  return {
    adminUserList,
    filters,
    createAdmin,
    handleSearchTerm,
    handleDownloadAdminUsers,
    handleDelete,
    handlePagination,
  };
};
